import { render, staticRenderFns } from "./form.vue?vue&type=template&id=bf4f5050&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf4f5050')) {
      api.createRecord('bf4f5050', component.options)
    } else {
      api.reload('bf4f5050', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=bf4f5050&", function () {
      api.rerender('bf4f5050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/demand-notice/form.vue"
export default component.exports